"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentType = exports.PaymentStatus = void 0;
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Pending"] = "Pending";
    // Delayed = 'Delayed',
    PaymentStatus["Paid"] = "Paid";
    PaymentStatus["Failed"] = "Failed";
    PaymentStatus["Canceled"] = "Canceled";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType["Full"] = "full";
    PaymentType["Installment"] = "installment";
    PaymentType["Addon"] = "addon";
    PaymentType["Deposit"] = "deposit";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
//# sourceMappingURL=Payment.js.map